import hljs from "highlight.js";
import "highlight.js/styles/github.css";

export const applyCustomClasses = (content) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = content;
    tempElement.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
    });

    tempElement.innerHTML = tempElement.innerHTML
        .replace(
            /<pre>/g,
            '<div class="custom-code-wrapper"><button class="copy-btn">Copy</button><pre class="custom-code-block">'
        )
        .replace(/<\/pre>/g, "</pre></div>")
        .replace(/<code>/g, '<code class="custom-code-block">')
        .replace(
            /<table>/g,
            '<div class="custom-table-wrapper"><table class="custom-table">'
        )
        .replace(/<\/table>/g, "</table></div>");

    tempElement.querySelectorAll("img").forEach((img) => {
        if (img.parentElement.classList.contains("custom-image-wrapper")) {
            const existingDownloadIcon = img.parentElement.querySelector(".custom-download-icon");
            if (existingDownloadIcon) {
                existingDownloadIcon.remove();
            }
            return;
        }

        img.classList.add("custom-generated-image");
        const downloadIcon = document.createElement("div");
        downloadIcon.classList.add("custom-download-icon");
        downloadIcon.setAttribute("aria-label", "Download Image");
        downloadIcon.setAttribute("title", "Download Image");
        const wrapper = document.createElement("div");
        wrapper.classList.add("custom-image-wrapper");
        const clonedImg = img.cloneNode(true);
        wrapper.appendChild(clonedImg);
        wrapper.appendChild(downloadIcon);
        img.parentNode.replaceChild(wrapper, img);
    });

    return tempElement.innerHTML;
};
